import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CopyToClipboardToastDirective } from './copy-to-clipboard-toast.directive';

@NgModule({
  declarations: [CopyToClipboardToastDirective],
  imports: [CommonModule],
  exports: [CopyToClipboardToastDirective],
})
export class CopyToClipboardToastModule {}

export { CopyToClipboardToastModule as CopyToClipboardModule };
